import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Entry2xmjmyutzoq3p as Entry } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MAP_getInstance3s1t6byguxmp9 as MAP_getInstance } from '../descriptors/SerialKinds.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
} from '../descriptors/SerialDescriptors.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Paire9pteg33gng7 as Pair,
  to2cs3ny02qtbcb as to,
  Triple1vhi3d0dgpnjb as Triple,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
var MapEntryClass;
function MapEntry() {
  if (MapEntryClass === VOID) {
    class $ {
      constructor(key, value) {
        this.i1j_1 = key;
        this.j1j_1 = value;
      }
      e2() {
        return this.i1j_1;
      }
      f2() {
        return this.j1j_1;
      }
      toString() {
        return 'MapEntry(key=' + toString(this.i1j_1) + ', value=' + toString(this.j1j_1) + ')';
      }
      hashCode() {
        var result = this.i1j_1 == null ? 0 : hashCode(this.i1j_1);
        result = imul(result, 31) + (this.j1j_1 == null ? 0 : hashCode(this.j1j_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MapEntry()))
          return false;
        var tmp0_other_with_cast = other instanceof MapEntry() ? other : THROW_CCE();
        if (!equals(this.i1j_1, tmp0_other_with_cast.i1j_1))
          return false;
        if (!equals(this.j1j_1, tmp0_other_with_cast.j1j_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MapEntry', VOID, VOID, [Entry()]);
    MapEntryClass = $;
  }
  return MapEntryClass;
}
var MapEntrySerializerClass;
function MapEntrySerializer() {
  if (MapEntrySerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        var tmp_0 = MAP_getInstance();
        tmp.m1j_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], ($this$buildSerialDescriptor) => {
          $this$buildSerialDescriptor.zz('key', keySerializer.az());
          $this$buildSerialDescriptor.zz('value', valueSerializer.az());
          return Unit_instance;
        });
      }
      az() {
        return this.m1j_1;
      }
      n1j(_this__u8e3s4) {
        return _this__u8e3s4.e2();
      }
      o1j(_this__u8e3s4) {
        return this.n1j((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      p1j(_this__u8e3s4) {
        return _this__u8e3s4.f2();
      }
      q1j(_this__u8e3s4) {
        return this.p1j((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      r1j(key, value) {
        return new (MapEntry())(key, value);
      }
    }
    initMetadataForClass($, 'MapEntrySerializer');
    MapEntrySerializerClass = $;
  }
  return MapEntrySerializerClass;
}
var PairSerializerClass;
function PairSerializer() {
  if (PairSerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        tmp.x1j_1 = buildClassSerialDescriptor('kotlin.Pair', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.zz('first', keySerializer.az());
          $this$buildClassSerialDescriptor.zz('second', valueSerializer.az());
          return Unit_instance;
        });
      }
      az() {
        return this.x1j_1;
      }
      y1j(_this__u8e3s4) {
        return _this__u8e3s4.af_1;
      }
      o1j(_this__u8e3s4) {
        return this.y1j(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      z1j(_this__u8e3s4) {
        return _this__u8e3s4.bf_1;
      }
      q1j(_this__u8e3s4) {
        return this.z1j(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      r1j(key, value) {
        return to(key, value);
      }
    }
    initMetadataForClass($, 'PairSerializer');
    PairSerializerClass = $;
  }
  return PairSerializerClass;
}
function decodeSequentially($this, composite) {
  var a = composite.y13($this.d1k_1, 0, $this.a1k_1);
  var b = composite.y13($this.d1k_1, 1, $this.b1k_1);
  var c = composite.y13($this.d1k_1, 2, $this.c1k_1);
  composite.m13($this.d1k_1);
  return new (Triple())(a, b, c);
}
function decodeStructure($this, composite) {
  var a = get_NULL();
  var b = get_NULL();
  var c = get_NULL();
  mainLoop: while (true) {
    var index = composite.b14($this.d1k_1);
    switch (index) {
      case -1:
        break mainLoop;
      case 0:
        a = composite.y13($this.d1k_1, 0, $this.a1k_1);
        break;
      case 1:
        b = composite.y13($this.d1k_1, 1, $this.b1k_1);
        break;
      case 2:
        c = composite.y13($this.d1k_1, 2, $this.c1k_1);
        break;
      default:
        throw SerializationException().p10('Unexpected index ' + index);
    }
  }
  composite.m13($this.d1k_1);
  if (a === get_NULL())
    throw SerializationException().p10("Element 'first' is missing");
  if (b === get_NULL())
    throw SerializationException().p10("Element 'second' is missing");
  if (c === get_NULL())
    throw SerializationException().p10("Element 'third' is missing");
  var tmp = (a == null ? true : !(a == null)) ? a : THROW_CCE();
  var tmp_0 = (b == null ? true : !(b == null)) ? b : THROW_CCE();
  return new (Triple())(tmp, tmp_0, (c == null ? true : !(c == null)) ? c : THROW_CCE());
}
var TripleSerializerClass;
function TripleSerializer() {
  if (TripleSerializerClass === VOID) {
    class $ {
      constructor(aSerializer, bSerializer, cSerializer) {
        this.a1k_1 = aSerializer;
        this.b1k_1 = bSerializer;
        this.c1k_1 = cSerializer;
        var tmp = this;
        tmp.d1k_1 = buildClassSerialDescriptor('kotlin.Triple', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.zz('first', this.a1k_1.az());
          $this$buildClassSerialDescriptor.zz('second', this.b1k_1.az());
          $this$buildClassSerialDescriptor.zz('third', this.c1k_1.az());
          return Unit_instance;
        });
      }
      az() {
        return this.d1k_1;
      }
      e1k(encoder, value) {
        var structuredEncoder = encoder.l13(this.d1k_1);
        structuredEncoder.c15(this.d1k_1, 0, this.a1k_1, value.tw_1);
        structuredEncoder.c15(this.d1k_1, 1, this.b1k_1, value.uw_1);
        structuredEncoder.c15(this.d1k_1, 2, this.c1k_1, value.vw_1);
        structuredEncoder.m13(this.d1k_1);
      }
      oz(encoder, value) {
        return this.e1k(encoder, value instanceof Triple() ? value : THROW_CCE());
      }
      pz(decoder) {
        var composite = decoder.l13(this.d1k_1);
        if (composite.a14()) {
          return decodeSequentially(this, composite);
        }
        return decodeStructure(this, composite);
      }
    }
    initMetadataForClass($, 'TripleSerializer', VOID, VOID, [KSerializer()]);
    TripleSerializerClass = $;
  }
  return TripleSerializerClass;
}
var KeyValueSerializerClass;
function KeyValueSerializer() {
  if (KeyValueSerializerClass === VOID) {
    class $ {
      constructor(keySerializer, valueSerializer) {
        this.s1j_1 = keySerializer;
        this.t1j_1 = valueSerializer;
      }
      u1j(encoder, value) {
        var structuredEncoder = encoder.l13(this.az());
        structuredEncoder.c15(this.az(), 0, this.s1j_1, this.o1j(value));
        structuredEncoder.c15(this.az(), 1, this.t1j_1, this.q1j(value));
        structuredEncoder.m13(this.az());
      }
      oz(encoder, value) {
        return this.u1j(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      pz(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.az();
        var composite = decoder.l13(descriptor);
        var tmp$ret$0;
        $l$block: {
          if (composite.a14()) {
            var key = composite.y13(this.az(), 0, this.s1j_1);
            var value = composite.y13(this.az(), 1, this.t1j_1);
            tmp$ret$0 = this.r1j(key, value);
            break $l$block;
          }
          var key_0 = get_NULL();
          var value_0 = get_NULL();
          mainLoop: while (true) {
            var idx = composite.b14(this.az());
            switch (idx) {
              case -1:
                break mainLoop;
              case 0:
                key_0 = composite.y13(this.az(), 0, this.s1j_1);
                break;
              case 1:
                value_0 = composite.y13(this.az(), 1, this.t1j_1);
                break;
              default:
                throw SerializationException().p10('Invalid index: ' + idx);
            }
          }
          if (key_0 === get_NULL())
            throw SerializationException().p10("Element 'key' is missing");
          if (value_0 === get_NULL())
            throw SerializationException().p10("Element 'value' is missing");
          var tmp = (key_0 == null ? true : !(key_0 == null)) ? key_0 : THROW_CCE();
          tmp$ret$0 = this.r1j(tmp, (value_0 == null ? true : !(value_0 == null)) ? value_0 : THROW_CCE());
        }
        var result = tmp$ret$0;
        composite.m13(descriptor);
        return result;
      }
    }
    initMetadataForClass($, 'KeyValueSerializer', VOID, VOID, [KSerializer()]);
    KeyValueSerializerClass = $;
  }
  return KeyValueSerializerClass;
}
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
//region block: exports
export {
  MapEntrySerializer as MapEntrySerializer2ukwamih4zw76,
  PairSerializer as PairSerializerpzh6nuee9oov,
  TripleSerializer as TripleSerializer25andm5j3t9nu,
};
//endregion

//# sourceMappingURL=Tuples.mjs.map
